import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // section name must match the name in the api (i.e. hasEnclosure, hasDropPipe, etc.)
    sections: {
      InternationalShip: false,
      // Add other sections as needed
    },
  };
  
  const sectionSlice = createSlice({
    name: 'sections',
    initialState,
    reducers: {
      updateSectionVisibility: (state, action) => {
        const { section, value } = action.payload;
        state.sections[section] = value;
      },
    },
  });
  
  export const { updateSectionVisibility } = sectionSlice.actions;
  export default sectionSlice.reducer;
  